import React from 'react'
import { Link } from 'react-router-dom'
import abImg from '../../images/about-image.jpg'
import { purpose } from '../../content/csp'

const ClickHandler = () => {
  window.scrollTo(10, 0)
}

const About = ({ showLink = true }) => {
  return (
    <section className="wpo-about-section-s2 section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-wrap">
              <div className="wpo-about-img">
                <img src={abImg} alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                <span>{purpose.kicker}</span>
                <h2>{purpose.title}</h2>
              </div>
              {purpose.paragraphs.map((paragraph) => (
                <p className="sub-text" key={paragraph}>
                  {paragraph}
                </p>
              ))}
              {showLink && (
                <Link onClick={ClickHandler} className="csp-more" to="/about">
                  Read why this exists
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
